export const formatPatientCardNumber = (cardNumber: string) => {
  if (cardNumber.length !== 6) {
    return cardNumber;
  }

  return `${cardNumber.slice(0, 3)} - ${cardNumber.slice(3, 6)}`;
};
